<style scoped>
#search_addressbook {
	padding: 0px;
}
</style>

<template>
	<v-container id="search_addressbook" fluid>
		<v-row no-gutters>
			<v-col cols="12" class="toolbar">
				<v-btn small @click="save_worklist()" v-if="show_result" class="mr-1 text-capitalize">Save worklist</v-btn>
				<v-btn small @click="new_search()" class="mr-1 text-capitalize">New search</v-btn>
			</v-col>
			<v-col cols="12" md="4" lg="3" v-if="show_search">
				<v-search-filter :search="search" @on_search="do_search()" ref="search" />
			</v-col>
			<v-col cols="12" md="8" lg="9" v-if="show_result">
				<v-btn text class="d-flex d-md-none ml-2 mt-2 text-capitalize" @click="on_back">&lt;&lt; back</v-btn>
				<v-search-results
					@click_abook="abook => open_abook(abook)"

					:show_columns="search.show_columns"
					@columns_changed="new_columns => search.show_columns = new_columns"
					
					:can_sort_columns="true"
					:sort_columns="search.sort_columns"
					@sort_changed="new_sort => search.sort_columns = new_sort"
					ref="results" 
				/>
			</v-col>
		</v-row>

		<v-new-worklist-dialog
			@saved="worklist => saved_worklist(worklist)"
			ref="new_worklist_dialog"
		/>
	</v-container>
</template>

<script>
import search_filter from "@/components/addressbook/search_filter";
import search_results from "@/components/addressbook/search_results";
import new_worklist_dialog from "@/components/worklist/new_worklist_dialog";
import { searchMixin } from "@/mixins/addressbook/searchMixin";

export default {
	mixins: [ searchMixin ],
	data() {
		return {
			window_width: 0,
			mode: 0, /* 0 = search, 1 = results */
			show_search: true,
			show_result: true
		}
	},
	components: {
		'v-search-filter': search_filter,
		'v-search-results': search_results,
		'v-new-worklist-dialog': new_worklist_dialog,
	},
	created() {
		// add this page to our breadcrumbs
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Search Address book",
			to: this.$route.path
		});
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.on_resize);

			// TODO need to check if we've stored search settings and if so re-execute them

			// call resize so we know our window size and apply our mode
			this.on_resize();
		})
	},
	beforeDestroy() { 
		window.removeEventListener('resize', this.on_resize); 
	},
	methods: {
		set_mode(new_mode) {
			this.mode = new_mode;

			this.show_search = (this.mode == 0) || (this.window_width >= 960);
			this.show_result = (this.mode == 1) || (this.window_width >= 960);
		},
		new_search() {
			// go back to our search window
			this.set_mode(0);

			this.$nextTick(() => {
				this.reset_search();
				this.$refs.results.clear_results();
			})
		},
		save_worklist() {
			let wl = {
				id: 0,
				class: "restful.addressbook.worklists",
				name: "",
				settings: { ...this.search },
				is_dynamic: true,
				details: []
			};

			// open up save dialog
			this.$refs.new_worklist_dialog.open(wl);
		},
		saved_worklist(worklist) {
			this.$router.push({ name: "Abook Worklist", params: {id : worklist.id }});
		},
		do_search() {
			this.set_mode(1);

			// TODO need to store these search settings somewhere so we return to it

			this.$nextTick(() => {
				if (this.search.show_columns.length == 0) {
					this.search.show_columns = this.$refs.results.default_columns()
				}
				this.$refs.results.perform_search(this.search);
			})
		},
		on_back() {
			this.set_mode(0);
		},
		open_abook(abook) {
			this.$router.push({ name: "View Addressbook", params: { id: abook.id }} );
		},
		on_resize() {
			this.window_width = window.innerWidth;
			this.set_mode(this.mode)
		}
	}}
</script>
